import UIButton from "../components/ui-kit/button";
import Operator from "../components/ui-kit/operator";

import "./uiKit.scss";

const UIKitSection = () => {
  return (
    <div className="page">
      <section className="ui-kit-section">
        <div className="container">
          <h3 className="section-title">[Technical Implementation]</h3>
          <h1>UI Kit for current project</h1>

          <h2>Butoane:</h2>
          <p>
            <UIButton text={"Salutares"} />{" "}
          </p>
          <p>
            <UIButton text={"balutares"} variant="secondary" />{" "}
          </p>
          <p>
            <UIButton text={"Salutares"} size="large" />{" "}
          </p>
          <p>
            <UIButton text={"balutares"} variant="secondary" size="large" />{" "}
          </p>

          <h2>Operatorii:</h2>
          <h2 style={{ "font-size": "64px", "line-height": "72px" }}>
            Se pot afla in titluri <Operator>SAU</Operator> in texte
          </h2>
          <p>
            Putand fi mari <Operator>SAU</Operator> mici, fiind relativi
          </p>
        </div>
      </section>

      <section className="ui-kit-section">
        <div className="container">
          <div className="row">
            <div className="col">
              <h3 className="section-title">[Bootstrap Implementation]</h3>
              <h2>Bootstrap Example</h2>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col">
              <h3>Jumatatile:</h3>
              <p>
                Daca punem 2 col pe un rand fara sa specificam size, se imparte
                automat latimea.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col">Jumatate tu</div>
            <div className="col">Jumatate eu</div>
          </div>
          <hr />
          <div className="row">
            <div className="col">
              <h3>Treimile:</h3>
              <p>
                Daca punem 3 col pe un rand fara sa specificam size, se imparte
                automat latimea.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col">Jumatate tu</div>
            <div className="col">Jumatate eu</div>
            <div className="col">Jumatate Dumnezeu</div>
          </div>
          <hr />

          <div className="row">
            <div className="col">
              <h3>Custom:</h3>
              <p>2-4-auto.</p>
            </div>
          </div>
          <div className="row">
            <div className="col-2">
              latime 2 col
              <hr />
            </div>
            <div className="col-4">
              latime 4 col
              <hr />
            </div>
            <div className="col">
              Auto
              <hr />
            </div>
            <div className="col">
              Autox2
              <hr />
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col">
              <h3>Responsiveness:</h3>
              <p>2-4-auto.</p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <h3>
                COLOANA ASTA incape de 3 ori pe desktop
                <br />
                de 2 ori pe tableta, si <br /> o singura data pe mobil{" "}
              </h3>
              <hr />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <h3>
                COLOANA ASTA incape de 3 ori pe desktop
                <br />
                de 2 ori pe tableta, si <br /> o singura data pe mobil{" "}
              </h3>
              <hr />
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <h3>
                COLOANA ASTA incape de 3 ori pe desktop
                <br />
                de 2 ori pe tableta, si <br /> o singura data pe mobil{" "}
              </h3>
              <hr />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default UIKitSection;
